{
  "cms.archive.action.archive": "Poista",
  "cms.archive.archiveError": "Arkistointi epäonnistui. Yritä uudelleen.",
  "cms.archive.confirm.body": "Sisältö siirtyy arkistoon, josta voit palauttaa sen tarvittaessa.",
  "cms.archive.confirm.cancel": "Peruuta",
  "cms.archive.confirm.confirm": "Poista",
  "cms.archive.confirm.title": "Poista \"{title}\"?",
  "cms.archive.deletedAt": "poistettu {date}",
  "cms.archive.description": "Poistetut rivit.",
  "cms.archive.empty": "Arkisto on tyhjä.",
  "cms.archive.errorState": "Arkiston lataus epäonnistui.",
  "cms.archive.loading": "Ladataan arkistoa…",
  "cms.archive.restore": "Palauta",
  "cms.archive.restored": "Palautettu arkistosta luonnoksiin.",
  "cms.archive.restoreError": "Palautus epäonnistui. Yritä uudelleen.",
  "cms.archive.title": "Arkisto",
  "cms.archive.trigger": "Arkisto",
  "cms.archive.type.banner": "Banneri",
  "cms.archive.type.benefit": "Etu",
  "cms.archive.type.homeCard": "Kortti",
  "cms.archive.type.article": "Sivu",
  "cms.archive.type.sidebarLink": "Nappi",
  "cms.archive.type.videoListing": "Lakiruutu-video"
}
